import Vue from "vue";
// import store from "@/store/store";

const state = {};

const actions = {
  wallet() {
    return Vue.prototype.$http.get("/api/wallet/v1", {
      responseType: "blob"
    });
  }
};

const mutations = {};

const getters = {};

export const wallet = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
